import { render, staticRenderFns } from "./webLink.vue?vue&type=template&id=397894bf&scoped=true"
import script from "./webLink.vue?vue&type=script&lang=js"
export * from "./webLink.vue?vue&type=script&lang=js"
import style0 from "./webLink.vue?vue&type=style&index=0&id=397894bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397894bf",
  null
  
)

export default component.exports